
import { defineComponent, ref, computed, onMounted } from 'vue'
import DOMPurify from 'dompurify'

const svgCache = new Map<string, string>();

export default defineComponent({
  props: {
    name: { type: String, required: true },
    width: { type: [String, Number], default: null },
    height: { type: [String, Number], default: null },
    color: { type: String, default: null }
  },
  setup(props) {
    const svgContent = ref('');
    const isLoading = ref(true);

    const placeholderStyle = computed(() => {
      const normalizeDimension = (value: string | number | null): string =>
        value !== null ? (typeof value === 'number' ? `${value}px` : value) : '1em';
      return {
        width: normalizeDimension(props.width),
        height: normalizeDimension(props.height),
      };
    });

    const S3_URL = process.env.NUXT_ENV_PARTNER_CLOUDFRONT_URL;

    onMounted(async () => {
      const url = `${S3_URL}/svg/${props.name}.svg`;

      try {
        let svg: string;

        if (svgCache.has(url)) {
          svg = svgCache.get(url)!;
        } else {
          const response = await fetch(url);
          svg = await response.text();
          svgCache.set(url, svg);
        }

        if (props.width !== null)  svg = svg.replace(/width="[^"]*"/, `width="${props.width}"`);
        if (props.height !== null) svg = svg.replace(/height="[^"]*"/, `height="${props.height}"`);

        svgContent.value = DOMPurify.sanitize(svg, { USE_PROFILES: { svg: true, svgFilters: true } });
      } catch (err) {
        console.error('Error loading icon from S3', err);
      } finally {
        isLoading.value = false;
      }
    });

    return { svgContent, isLoading, placeholderStyle }
  }
})
